import * as React from 'react';

import { Wrapper, ImageWrapper, Image, TextWrapper, Text, Dots, Dot, Arrow } from './styles';
import { SlideTextPosition } from '../../../../../../../containers/Editor/utils/indesignEditor/editableSliders/getData';
import Utils from '../../../../../../../utils';

interface SlidePreviewProps {
	url: string;
	width: number;
	height: number;
	shouldImageScale?: boolean;
	isBackgroundSlide?: boolean;
	textValue: string;
	textFontFamily: string;
	textSize: number;
	textColor: string;
	textBackgroundColor?: string;
	textShadowColor?: string;
	textPosition: SlideTextPosition;
	slidesLength: number;
}

const MAX_DOTS = 5;

const SlidePreview = ({
	url,
	width,
	height,
	shouldImageScale,
	isBackgroundSlide,
	textValue,
	textFontFamily,
	textSize,
	textColor,
	textBackgroundColor,
	textShadowColor,
	textPosition,
	slidesLength,
}: SlidePreviewProps) => {
	const wrapperElement = React.useRef<HTMLDivElement>(null);
	const [textScale, setTextScale] = React.useState(1);

	React.useLayoutEffect(() => {
		if (wrapperElement.current) {
			const { offsetWidth } = wrapperElement.current;
			setTextScale(offsetWidth / width);
		}
	}, [width]);

	const dotsLength = Math.min(slidesLength, MAX_DOTS);

	return (
		<Wrapper ref={wrapperElement}>
			<ImageWrapper
				width={width}
				height={height}
			>
				<Image
					src={url}
					shouldScale={shouldImageScale}
				/>
				{!isBackgroundSlide &&
					<>
						<Dots itemsLength={dotsLength}>
							{Array.from({ length: dotsLength }, (v, i) => i + 1).map(i => (
								<Dot key={i} />
							))}
						</Dots>
						<Arrow>
							{Utils.getSvgIcon('iconset_back')}
						</Arrow>
						<Arrow isRight={true}>
							{Utils.getSvgIcon('iconset_back')}
						</Arrow>
					</>
				}
			</ImageWrapper>
			<TextWrapper
				position={textPosition}
				isBackgroundSlide={isBackgroundSlide}
			>
				<Text
					dangerouslySetInnerHTML={{ __html: textValue }}
					fontFamily={textFontFamily}
					size={textSize * textScale}
					color={textColor}
					backgroundColor={textBackgroundColor}
					shadowColor={textShadowColor}
					position={textPosition}
				/>
			</TextWrapper>
		</Wrapper>
	);
};

export default SlidePreview;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SliderManager/Slide/TextEditor/SlidePreview/index.tsx